// Mirrors backend `_same_day` (routes/shows.py): compares dates and weekday
// names interchangeably, so a '2026-05-30' class matches a 'Saturday' sidepot.
const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const ABBR = { mon: 'monday', tue: 'tuesday', tues: 'tuesday', wed: 'wednesday', weds: 'wednesday', thu: 'thursday', thur: 'thursday', thurs: 'thursday', fri: 'friday', sat: 'saturday', sun: 'sunday' };

const normalizeWeekday = (s) => {
  const v = String(s).trim().toLowerCase().replace(/s$/, '');
  if (WEEKDAYS.includes(v)) return v;
  return ABBR[v] || null;
};

const weekdayFromDate = (s) => {
  const v = String(s).trim();
  let m = v.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
  let y, mo, d;
  if (m) { [, y, mo, d] = m; } else {
    m = v.match(/^(\d{1,2})[-/](\d{1,2})(?:[-/](\d{4}))?$/);
    if (m) { [, mo, d, y] = m; y = y || new Date().getFullYear(); } else {
      const t = Date.parse(v);
      return Number.isNaN(t) ? null : WEEKDAYS[new Date(t).getDay()];
    }
  }
  const dt = new Date(Number(y), Number(mo) - 1, Number(d), 12);
  return Number.isNaN(dt.getTime()) ? null : WEEKDAYS[dt.getDay()];
};

const dayKey = (x) => {
  const date = String(x?.scheduled_date || '').trim();
  if (date) return { date: date.toLowerCase(), weekday: weekdayFromDate(date) };
  const day = String(x?.scheduled_day || '').trim();
  if (day) return { date: null, weekday: normalizeWeekday(day) || day.toLowerCase() };
  return null;
};

// True when a and b run on the same day. Unscheduled items always match.
export const isSameDay = (a, b) => {
  const ka = dayKey(a);
  const kb = dayKey(b);
  if (!ka || !kb) return true;
  if (ka.date && kb.date) {
    if (ka.date === kb.date) return true;
    if (!ka.weekday || !kb.weekday) return false;
  }
  return !!ka.weekday && ka.weekday === kb.weekday;
};
